import React from 'react';
import theme from '../../styles/theme';
import {Box, TextField, Typography} from '@mui/material';
import {CONSTANTS} from '../../constants';
import {isSpecialCharacterIncludes} from '../../utils';

const TextInput = ({label, error, helperText, labelColor, disabled, labelVariant, labelBottomGap, onChange, isAllowSpecialChar = false, maxLength, readOnly = false, colorBlack, paddingBlock, bottomLabel, mb = 1, height, width = '100%', style = {}, type = 'text', sx, ...rest}) => {
  return (
    <Box display="flex" flexDirection="column" mb={mb} width={width}>
      {label && (
        <Box sx={{marginBottom: labelBottomGap || 0}}>
          <Typography 
            textAlign="left" 
            color={labelColor} 
            variant={labelVariant} 
            gutterBottom={false}
          >
            {label.toUpperCase()}
          </Typography>
        </Box>
      )}
      <TextField
        error={error ? true : false}
        helperText={helperText}
        autoComplete="off"
        disabled={disabled}
        sx={{
          paddingBlock: paddingBlock ? paddingBlock : 0,
          ...(height && {
            '& .MuiOutlinedInput-root': {
              height: height,
              '& .MuiOutlinedInput-input': {
                padding: '8px 14px',
                // height: 'auto',
                height: height,
                display: 'flex',
                alignItems: 'center'
              }
            }
          }),
          ...sx
        }}
        InputProps={{
          theme: theme
        }}
        type={type}
        inputProps={{
          maxLength: maxLength ? maxLength : CONSTANTS.TEXT_FIELD_MAX_LENGTH,
          readOnly: readOnly,
          className: colorBlack ? colorBlack : '',
          style: style
        }}
        onChange={e => (isAllowSpecialChar ? onChange(e) : !isSpecialCharacterIncludes(e.target.value) && onChange(e))}
        {...rest}
      />
      {bottomLabel && (
        <Box sx={{marginBottom: labelBottomGap || 0}}>
          <Typography 
            textAlign="left" 
            color={labelColor} 
            variant={labelVariant} 
            gutterBottom={false}
          >
            {bottomLabel}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default TextInput;
